// Themed use-case groups shown as dropdown "pills" on the AI Assistant
// surfaces (home command center + chat-panel welcome screen). Each item's
// `label` is the friendly menu entry; selecting it fills the composer with
// `prompt`. See the spec: "AI Assistant Use Case Pills".
export const USE_CASE_GROUPS = [
    {
        id: 'discovery',
        label: 'Discovery',
        items: [
            {
                label: 'Identify growth trends in my industry',
                prompt: 'What are the fastest growing subcategories in beauty?',
            },
            {
                label: 'Spot early trends',
                prompt: 'What are the early stage trends in skincare?',
            },
            {
                label: 'Find up-and-coming brands',
                prompt: 'What are the up-and-coming beauty brands right now?',
            },
            {
                label: 'Discover growing ingredients',
                prompt: 'What ingredients are growing in skincare?',
            },
        ],
    },
    {
        id: 'marketing',
        label: 'Marketing',
        items: [
            {
                label: 'See what’s trending on TikTok right now',
                prompt: 'What hashtags are trending in skincare on TikTok this week?',
            },
            {
                label: 'Identify organic TikTok hashtag opportunities',
                prompt: 'What hashtags are growing organically in face moisturizer on TikTok?',
            },
            {
                label: 'Find the right creators',
                prompt: 'Find niche TikTok creators for face moisturizer with high engagement and low paid views.',
            },
            {
                label: 'Boost winning content',
                prompt: 'What are Karseell’s top organic TikTok posts right now?',
            },
        ],
    },
    {
        id: 'strategy',
        label: 'Strategy',
        items: [
            {
                label: 'Track my brand',
                prompt: 'How is Karseell doing?',
            },
            {
                label: 'Benchmark competitors',
                prompt: 'Which brands are winning in shampoo?',
            },
            {
                label: 'Compare a trend across platforms',
                prompt: 'Is glass skin bigger on TikTok, Google, or Instagram?',
            },
            {
                label: 'Claims & positioning optimization',
                prompt: 'What concerns are consumers associating with retinol?',
            },
            {
                label: 'Consumer sentiment analysis',
                prompt: 'Which TikTok posts about Karseell have the most positive sentiment?',
            },
        ],
    },
];
